export const sexData = [
    "MAN",
    "WOMAN",
    "OTHER",
    "AGENDER",
    "ANDROGYNOUS",
    "BIGENDER",
    "GENDER FLUID",
    "GENDER NON CONFORMING",
    "GENDER QUEER",
    "GENDER QUESTIONING",
    "INTERSEX",
    "NON-BINARY",
    "PANGENDER",
    "TRANS HUMAN",
    "TRANS MAN",
    "TRANS WOMAN",
    "TRANSFEMINIME",
    "TRANSMASCULINE",
    "TWO-SPIRIT",
];

export const oriData = [
    "STRAIGHT",
    "GAY",
    "LESBIAN",
    "BISEXUAL",
    "ANDROGYNOUS",
    "BIGENDER",
    "BI-CURIOUS",
    "PANSEXUAL",
    "POLYSEXUAL",
    "QUEER",
    "ANDROGYNOBEXUAL",
    "ASEXUAL",
    "AUTOSEXUAL",
    "DEMISEXUAL",
    "GRAY A",
    "GYNOSEXUAL",
    "HETEROFLEXIBLE",
    "HOMOFLEXIBLE",
    "OBJECTUMSEXUAL",
    "OMNISEXUAL",
    "SKOLIOSEXUAL",
];
export const statusData = [
    "SINGLE",
    "MAN + WOMAN COUPLE",
    "MAN + MAN COUPLE",
    "WOMAN + WOMAN COUPLE"
];
export const lookingForData = [
    "RELATIONSHIP",
    "FRIENDSHIP",
    "CASUAL",
    "FUN",
    "DATES",
    "TEXTING",
];
export const showData = [
    "MEN",
    "WOMEN",
    "MAN + WOMAN COUPLE",
    "MAN + MAN COUPLE",
    "WOMAN + WOMAN COUPLE",
    "GENDER FLUID",
    "GENDER NON CONFORMING",
    "GENDER QUEER",
    "AGENDER",
    "ANDROGYNOUS",
    "GENDER QUESTIONING",
    "INTERSEX",
    "NON-BINARY",
    "PANGENDER",
    "TRANS HUMAN",
    "TRANS MAN",
    "TRANS WOMAN",
    "TRANSFEMINIME",
    "TRANSMASCULINE",
    "TWO-SPIRIT",
];
